// useBottomNavItems.ts
// Ítems fijos del bottom nav, resueltos desde la configuración compartida con el Sidebar.
import { computed, type FunctionalComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ALL_SECTIONS, BOTTOM_NAV_FIXED_IDS, resolveNavSection, type NavSectionId } from '@/config/navigation'

export interface BottomNavItem {
  id: NavSectionId
  label: string
  icon: FunctionalComponent
  path: string
  active: boolean
}

// Labels propios del pill mobile: distintos a los del Sidebar (Agenda vs Calendario, Inicio vs Dashboard).
const FIXED_LABELS: Partial<Record<NavSectionId, string>> = {
  clients: 'Clientes',
  calendar: 'Agenda',
  citas: 'Citas',
  dashboard: 'Inicio'
}

const sectionById = (id: NavSectionId) => ALL_SECTIONS.find((section) => section.id === id)

export function useBottomNavItems() {
  const route = useRoute()
  const router = useRouter()

  const currentSection = computed(() => resolveNavSection(route.path))

  const items = computed<BottomNavItem[]>(() =>
    BOTTOM_NAV_FIXED_IDS.map((id) => {
      const section = sectionById(id)!
      return {
        id,
        label: FIXED_LABELS[id] ?? section.label,
        icon: section.icon,
        path: section.path,
        active: currentSection.value?.id === id
      }
    })
  )

  const goTo = (path: string): void => {
    router.push(path)
  }

  return { items, goTo }
}
